<template>
  <div>
    <v-dialog v-model="value" persistent max-width="630px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs12 mt-4>
                <v-slider
                  :label="$t('parents.modal_qr.qr_code_size')"
                  v-model="size"
                  max="360"
                  min="120"
                  thumb-color="red"
                  step="240"
                  ticks="always"
                  tick-size="2"
                  thumb-size="50"
                  thumb-label="always"
                >
                  <template v-slot:thumb-label="props">
                    <span>
                      {{ thumbText() }}
                    </span>
                  </template>
                </v-slider>
              </v-flex>
              <v-flex xs12>
                <div color="primary">
                  {{
                    `${$t('parents.modal_qr.qr_code_size')} ${
                      size == 120 ? '12' : '9'
                    } ${$t('parents.modal_qr.qr_code_size_2')}
                    `
                  }}
                </div>
              </v-flex>
              <v-flex xs12>
                <div>
                  <v-checkbox
                    color="primary"
                    id="required"
                    v-model="space"
                    :label="$t('parents.modal_qr.page_breaks_groups')"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">
            {{ $t('parents.modal_qr.cancel') }}
          </v-btn>
          <v-btn
            :disabled="working.wUpdate"
            color="primary darken-1"
            flat
            @click="submit"
          >
            {{ $t('parents.modal_qr.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['title', 'value'],

  watch: {
    value() {},
  },
  mounted() {},
  data: () => ({
    modals: {},
    size: 120,
    space: false,
    working: {
      wUpdate: false,
      wImage: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    ticks: ['Pequeño', 'Grande'],
  }),
  methods: {
    thumbText() {
      if (this.size == 120) return this.$t('parents.modal_qr.small')
      return this.$t('parents.modal_qr.large')
    },
    close() {
      document.getElementById('img_edit_employee').innerHTML = ``
      document.getElementById('img_edit_employee').style.display = 'none'
      document
        .getElementById('parentContainerEmployeeImage')
        .classList.add('gradiente')
      document.getElementById('img_edit_employee_default').style.display =
        'block'
      this.$emit('input', !this.value)
    },
    submit() {
      this.$emit('desition', {
        value: true,
        size: this.size,
        space: this.space,
      })
    },
    tick(val) {
      return this.ticks[val]
    },
  },
  computed: {},
}
</script>
<style>
.imgQrPadding {
  padding-left: 10%;
}
</style>
